import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { I18nContext } from '@bingads-webui-react/i18n-context';
import { Wallet24Regular } from '@fluentui/react-icons';
import { ValidatedCollapseCard, FormCardBasicHeader } from '@bingads-webui-campaign-react/validated-form-cards';
import { FormCardBody } from '@bingads-webui-fluent-component/form-cards';
import { andComp, propertyIs, entityIs } from '@bingads-webui-campaign-react/form-error';
import { withControlErrorHandling, withUnvalidatedControlErrors } from '@bingads-webui-campaign-react/error-handling';
import { ERROR_ENTITY } from '@bingads-webui-campaign-react/linkedin-data';
import { ValidatedBudgetInput } from '@bingads-webui-campaign-react/budget-component-v2';
import { LinkedInBudgetRangePerCurrency } from '@bingads-webui-campaign-legacy/common-grid-config/budget/get-budget-range';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';

import { BudgetSkeleton } from '../components/skeletons';

const entityIsCampaign = entityIs(ERROR_ENTITY.Campaign);
const campaignBudgetProp = andComp(entityIsCampaign, propertyIs('Budget'));

const ServerValidatedBudget = withControlErrorHandling(withUnvalidatedControlErrors(ValidatedBudgetInput, { filter: campaignBudgetProp }));

export const BudgetCard = ({ data, ...cardProps }) => {
  const i18n = useContext(I18nContext);
  const serverContext = useContext(ServerContext);
  const currencyCode = (serverContext && serverContext.CurrentAccount && serverContext.CurrentAccount.CurrencyCode) || 'USD';
  const { budgetAmount } = data || {};

  return (
    <ValidatedCollapseCard {...cardProps}>
      <FormCardBasicHeader
        title={i18n.getString(_TL_('Budget'))}
        contentBefore={<Wallet24Regular />}
        helpTopic="pop_BA_LinkedIn_Budget"
        helpLabel={i18n.getString(_TL_('Click to learn more about budget'))}
      />
      <FormCardBody>
        {data ? (
          <ServerValidatedBudget
            validationProps={{ data: { budgetAmount } }}
            budgetKey="budgetAmount"
            label={i18n.getString(_TL_('How much would you like to spend each day?'))}
            minBudget={LinkedInBudgetRangePerCurrency[currencyCode].Min}
            maxBudget={LinkedInBudgetRangePerCurrency[currencyCode].Max}
          />
        ) : (
          <BudgetSkeleton />
        )}
      </FormCardBody>
    </ValidatedCollapseCard>
  );
};

BudgetCard.propTypes = {
  data: PropTypes.shape({}).isRequired,
  error: PropTypes.shape({}).isRequired,
};
